import { creatorEconomyApi } from '../utils'
import { API_END_POINT, API_METHOD, ensureAiToolId, AI_TOOL_IDS, resolveToolId } from '../utils/constants'
import { apiRequest, socialApiRequest } from './apiWrapper'

export async function discoverApi() {
  const response = await apiRequest({
    method: 'get',
    url: 'content/'
  })
  return response
}

export async function fetchDiscoverData(limit = 10, offset = 5) {
  return socialApiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.feed,
    params: { limit, offset }
  })
}

export async function likeContent(content_id, isUGC) {
  const socialCall = () =>
    socialApiRequest({
      method: 'post',
      url: 'like/',
      data: { content_id }
    })

  const creatorCall = () =>
    creatorEconomyApi({
      method: 'post',
      url: '/like/',
      data: { template_id: content_id }
    })

  if (isUGC === true) return socialCall()
  if (isUGC === false) return creatorCall()

  try {
    return await socialCall()
  } catch {
    return creatorCall()
  }
}

export async function unlikeContent(content_id, isUGC) {
  const socialCall = () =>
    socialApiRequest({
      method: 'delete',
      url: `like/`,
      data: { content_id }
    })

  const creatorCall = () =>
    creatorEconomyApi({
      method: 'delete',
      url: '/like/',
      data: { template_id: content_id }
    })

  if (isUGC === true) return socialCall()
  if (isUGC === false) return creatorCall()

  try {
    return await socialCall()
  } catch {
    return creatorCall()
  }
}

export async function fetchUserLikes(token) {
  return socialApiRequest({
    method: 'get',
    url: 'like/',
    headers: token ? { 'x-api-token': token } : undefined
  })
}

export async function fetchLikesByContentId(
  content_id,
  page = 1,
  limit = 20,
  isUGC
) {
  const socialCall = async () => {
    const response = await socialApiRequest({
      method: 'get',
      url: 'like/',
      params: { content_id, page, limit }
    })
    return response?.data
  }

  const creatorCall = async () => {
    const response = await creatorEconomyApi({
      method: 'get',
      url: 'like/',
      params: { template_id: content_id, page, limit }
    })
    return response?.data?.data
  }

  if (isUGC === true) return socialCall()
  if (isUGC === false) return creatorCall()

  try {
    return await socialCall()
  } catch {
    return creatorCall()
  }
}

export async function fetchLikesByContentIdAndSearch(
  content_id,
  search,
  page = 1,
  limit = 20
) {
  return socialApiRequest({
    method: 'get',
    url: 'like/',
    params: { content_id, search, page, limit }
  })
}

export async function fetchCommentsByContentId(
  content_id,
  isUGC,
  page = 1,
  limit = 20
) {
  const mapSocialComments = (response) => {
    if (response?.data?.comments) {
      return response.data.comments.map((comment) => ({
        ...comment,
        id: comment.comment_id,
        username: comment.user_name,
        profile_picture: comment.profile_image
      }))
    }
    return []
  }

  const mapCreatorComments = (response) => {
    if (response?.data?.data?.comments) {
      return response.data.data.comments.map((comment) => ({
        ...comment,
        id: comment.comment_id,
        username: comment.user_name,
        profile_picture: comment.profile_image
      }))
    }
    return []
  }

  const socialCall = async () => {
    const response = await socialApiRequest({
      method: 'get',
      url: `comment/${content_id}`,
      params: { page, limit }
    })
    const comments = mapSocialComments(response)
    return {
      comments,
      next: response?.data?.next || (comments.length === limit ? page + 1 : null)
    }
  }

  const creatorCall = async () => {
    const response = await creatorEconomyApi({
      method: 'get',
      url: 'comment/',
      params: { content_id, page, limit }
    })
    const comments = mapCreatorComments(response)
    return {
      comments,
      next:
        response?.data?.data?.next ||
        (comments.length === limit ? page + 1 : null)
    }
  }

  if (isUGC === true) return socialCall()
  if (isUGC === false) return creatorCall()

  try {
    return await socialCall()
  } catch {
    return creatorCall()
  }
}

export async function postCommentAPI({
  user_id,
  content_id,
  comment_text,
  isUGC
}) {
  const socialCall = () =>
    socialApiRequest({
      method: 'post',
      url: 'comment/',
      data: { content_id, comment_text }
    })

  const creatorCall = () =>
    creatorEconomyApi({
      method: 'post',
      url: '/comment/',
      data: { template_id:content_id, comment_text }
    })

  if (isUGC === true) return socialCall()
  if (isUGC === false) return creatorCall()

  try {
    return await socialCall()
  } catch {
    return creatorCall()
  }
}

export async function fetchPopularTools() {
  return apiRequest({
    method: 'get',
    url: '/popular_tools/'
  })
}

export async function fetchPickFromList() {
  return apiRequest({
    method: 'get',
    url: '/pickfromlist/',
    skipCache: true
  })
}

export async function fetchVideoPickFromList() {
  return apiRequest({
    method: 'get',
    url: '/video_pickfromlist/',
    skipCache: true
  })
}

export async function fetchDoMore(toolId, contentId) {
  const resolvedToolId = ensureAiToolId(toolId) || (toolId ? resolveToolId(toolId) : null) || toolId || AI_TOOL_IDS.FACE_SWAP
  return apiRequest({
    method: 'get',
    url: `/domoretools/${resolvedToolId}`,
    params: { content_id: contentId }
  })
}
